import axios from 'axios';
import React from 'react';
import { Col, Container, Row } from 'react-grid-system';

import { EVENT } from '../../globals';

import { useApp } from '../_libs/hooks/useApp';
import { useBrand } from '../_libs/hooks/useBrand';

const Navigation = (): JSX.Element => {
  const {
    reportData,
    userId,
  } = useApp();
  const { 
    primaryBrand,
    isCoBranded,
    coBrand,
    coBrandUrl,
  } = useBrand();
  const brandName = (isCoBranded) ? `radian™ for ${coBrand.name}` : 'radian™';
  const bgColor = (isCoBranded) ? coBrand.colors.dark : 'black';
  let url = (isCoBranded) ? `/${coBrandUrl}/` : '/';
  // 'lb' url is not cobranded but does have special risk driver limits
  if (coBrandUrl === 'lb') {
    url = '/lb/';
  }

  function handleStartOver () {
    axios.
      post('/create_event/', {
        organizationId: primaryBrand.id,
        coBrandId: coBrand.id,
        reportId: reportData.id,
        userId,
        eventCode: EVENT.UIStartOver,
      });
  }

  return (
    <div className="navigation" style={{
      position: 'sticky',
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: bgColor,
      zIndex: 3,
    }}>
      <Container>
        <Row justify="between" align="center" style={{
          height: '3rem'
        }}>
          <Col>
            <div style={{
              display: 'flex',
              alignItems: 'center',
            }}>
              <a href={url} className="logo td-none pa-0 ma-0" onClick={handleStartOver}>{brandName}</a>
            </div>
          </Col>
          <Col sm="content">
            <div style={{
              display: 'flex',
              alignItems: 'center',
            }}>
              <span
                className="inline-block mr-4 f-xs f-mono"
                style={{
                  color: 'rgba(255, 255, 255, 0.5)',
                }}
              >
                v2.4.7
              </span>
              <a
                href={url}
                className="f-sans f-light f-small td-none br-1"
                style={{
                  padding: '0.5rem 0.75rem',
                  border: '1px solid rgba(255, 255, 255, 0.25)',
                  backgroundColor: bgColor,
                }}
                onClick={handleStartOver}>
                  Start Over
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Navigation;
